import { tokenStore } from "core/authentication";
import { appConfig } from "shared/app-config";

const addTokenInRequest = async (request) => {
  let authToken;
  authToken = tokenStore.getAuthToken();

  if (
    authToken &&
    !request.headers["skipAuth"]
  ) {
    request.headers.Authorization = `Bearer ${authToken}`;

    if (tokenStore.isSSOToken()) {
      request.headers['isSSO'] = true;
    }
  }

  return request;
};

const addFunctionKeyInRequest = async (request) => {
  request.headers['x-functions-key'] = appConfig.FUNCTIONS_KEY;

  return request;
};

export const requestInterceptors = [addTokenInRequest, addFunctionKeyInRequest];
